<template>
    <div class="mallIndexWrap">
        <div class="searchBar" @click="goSearch">
            <div class="search center">
                <img src="../../../static/imgs/movie/search.png" alt />
                <span>搜索</span>
            </div>
        </div>
        <div class="scrollBar fr">
            <div
                :class="selectedCategoryId == item.categoryId ? 'scrollItem selected' : 'scrollItem'"
                v-for="(item, index) in categoryList"
                :key="index"
                @click="selectCategory(item.categoryId, index)"
            >
                <img :src="item.logo" alt />
                <span>{{item.name}}</span>
            </div>
        </div>
        <!-- <div class="leftBar" :style="isIPhoneX || isIPhoneXSMax || isIPhoneXR ? 'padding-bottom: 138px;' : 'padding-bottom: 98px;'"> -->
        <div :class="isIPhoneX || isIPhoneXSMax || isIPhoneXR ? 'leftBar pb138' : 'leftBar pb98'" >
            <span
                :class="selectedSubId == item.id ? 'selected' : ''"
                v-for="(item, index) in subCategoryList"
                :key="index"
                @click="selectSubCategory(item.id)"
            >{{item.name}}</span>
        </div>
        <div class="filterBar frr ac">
            <div class="fr ac" @click="sort('price')">
                <span :class="sortField == 'price' ? 'active' : ''">价格</span>
                <img class="sortIcon" :src="sortField == 'price' && asc ? ascIcon : sortField == 'price' ? descIcon : defaultIcon" alt />
            </div>
            <div class="fr ac" @click="sort('sold')">
                <span :class="sortField == 'sold' ? 'active' : ''">销量</span>
                <img class="sortIcon" :src="sortField == 'sold' && asc ? ascIcon : sortField == 'sold' ? descIcon : defaultIcon" alt />
            </div>
            <span :class="sortField == '' ? 'active' : ''" @click="sort('')">综合</span>
        </div>
        <div
            :class="isIPhoneX || isIPhoneXSMax || isIPhoneXR ? 'productList fc pb138' : 'productList fc pb98'"
            v-infinite-scroll="loadMore"
            infinite-scroll-disabled="loading"
            infinite-scroll-distance="0"
        >
            <div class="productItem fr" v-for="(item, index) in productList" :key="index" @click="viewProduct(item.productId)">
                <img :src="item.logo" alt />
                <dir class="productInfo fc jsb">
                    <h3>{{item.name}}</h3>
                    <span class="sales">已售：{{item.sold}}件</span>
                    <div class="fr ac jsb">
                        <span class="price">
                            <strong>￥{{item.priceDesc}}</strong>
                            <span>{{item.marketPrice}}</span>
                        </span>
                    </div>
                </dir>
            </div>
        </div>
        <img src="../../../static/imgs/mall/cart.png" @click="toCart" class="cartIcon">
        <tab-bar></tab-bar>
    </div>
</template>

<script>
import tabBar from "../../components/common/tabBar.vue";
export default {
    data() {
        return {
            categoryList: [],
            selectedCategoryId: "",
            subCategoryList: [],
            selectedSubId: "",
            productList: [],
            pageNo: 1,
            sortField: "",
            asc: "",
            ascIcon: require("../../../static/imgs/mall/asc.png"),
            descIcon: require("../../../static/imgs/mall/desc.png"),
            defaultIcon: require("../../../static/imgs/mall/default.png"),
            isIPhoneX: this.$global.isIPhoneX,
            isIPhoneXSMax: this.$global.isIPhoneXSMax,
            isIPhoneXR: this.$global.isIPhoneXR,
            // loading: false
        };
    },
    // activated(){
    //     this.loading = false
    // },
    created() {
        this.getCategoryList();
        console.log('isIPhoneX',this.$global.isIPhoneX)
    },
    watch: {
        selectedCategoryId(val, oldVal) {
            console.log("selectedCategoryId",`val ${val}`, `oldVal ${oldVal}`)
            this.selectedSubId = "";
            this.pageNo = 1;
            this.productList = [];
            this.getProductList();
        },
        selectedSubId(val, oldVal){
            console.log("selectedSubId",`val ${val}`, `oldVal ${oldVal}`)
            this.pageNo = 1;
            this.productList = [];
            this.getProductList();
        }
    },
    components: {
        tabBar
    },
    methods: {
        getCategoryList() {
            this.$post({
                method: "mall.product.categoryandsub.list"
            }).then(res => {
                if (res.success) {
                    this.categoryList = res.data;
                    this.selectedCategoryId = res.data[0].categoryId;
                    let arr = [{ id: "", name: "全部" }];
                    this.subCategoryList = arr.concat(
                        res.data[0].subCategoryList
                    );
                    this.getProductList();
                }
            });
        },
        selectCategory(id, idx) {
            this.selectedCategoryId = id;
            let arr = [{ id: "", name: "全部" }];
            this.subCategoryList = arr.concat(
                this.categoryList[idx].subCategoryList
            );
        },
        selectSubCategory(id) {
            this.selectedSubId = id;
        },
        getProductList() {
            this.$post({
                method: "mall.product.list",
                categoryId: this.selectedCategoryId,
                subCategoryId: this.selectedSubId,
                pageNo: this.pageNo,
                sortField: this.sortField,
                asc: this.asc
            }).then(res => {
                if (res.success) {
                    this.productList = this.productList.concat(
                        res.data.productList
                    );
                }
            });
        },
        // 加载更多
        loadMore() {
            if (this.$route.path == "/mallIndex" && this.selectCategory) {
                this.pageNo++;
                this.getProductList();
            }
        },
        viewProduct(id){
            // this.loading = true
            this.$router.push({path: "/productDetail", query: {productid: id}})
        },
        // 商品排序
        sort(type){
            this.sortField = type;
            this.asc = this.asc ? false : true;
            this.pageNo = 1;
            this.productList = [];
            this.getProductList();
        },
        goSearch(){
            this.$router.push({path: "/searchCinema"})
        },
        toCart(){
            this.$router.push({path: "/cart"})
        }
    }
};
</script>
<style lang="scss">
.mallIndexWrap {
    width: 100%;
    .searchBar {
        position: fixed;
        top: 0;
        width: 100%;
        height: 100px;
        background: #f2f2f2;
        .search {
            width: 700px;
            height: 60px;
            border-radius: 30px;
            background: #fff;
            margin: 20px 25px;
            img {
                width: 25px;
                height: 25px;
                margin-right: 15px;
            }
        }
    }
    .scrollBar {
        position: fixed;
        top: 100px;
        width: 100%;
        height: 160px;
        overflow-x: scroll;
        white-space: nowrap;
        background: #f2f2f2;
        .scrollItem {
            width: 135px;
            height: 160px;
            display: inline-block;
            img {
                width: 85px;
                height: 88px;
                margin: 0 25px;
                float: left;
            }
            span {
                width: 111px;
                height: 30px;
                line-height: 30px;
                text-align: center;
                font-size: 22px;
                float: left;
                margin: 18px 12px 0 12px;
            }
        }
        .selected {
            img {
                border: 4px solid #e42f46;
                box-sizing: border-box;
                border-radius: 43px;
            }
            span {
                background: #e42f46;
                color: #fff;
                border-radius: 15px;
            }
        }
    }
    .scrollBar::-webkit-scrollbar {
        display: none;
    }
    .leftBar {
        position: fixed;
        top: 260px;
        left: 0;
        background: #fff;
        width: 180px;
        height: calc(100% - 260px);
        border-right: 1px solid #dededf;
        overflow-y: scroll;
        span {
            width: 178px;
            height: 100px;
            font-size: 28px;
            line-height: 100px;
            text-align: center;
            padding: 0 15px;
            box-sizing: border-box;
            position: relative;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            display: inline-block;
        }
        .selected {
            color: #e42f46;
        }
        .selected::before {
            position: absolute;
            left: 0;
            top: 34px;
            background: #e42f46;
            width: 8px;
            height: 32px;
            content: "";
        }
    }
    .leftBar::-webkit-scrollbar {
        display: none;
    }
    .filterBar {
        width: 570px;
        height: 60px;
        position: fixed;
        top: 260px;
        right: 0;
        background: #fff;
        border-bottom: 1px solid #dededf;
        font-size: 22px;
        padding: 0 25px;
        box-sizing: border-box;
        div {
            margin-left: 35px;
            img {
                width: 10px;
                height: 16px;
                margin-left: 12px;
            }
        }
        .active {
            color: #E42F46;
        }
    }
    .productList {
        width: 100%;
        padding-top: 320px;
        padding-left: 180px;
        box-sizing: border-box;
        .productItem {
            width: 100%;
            padding: 30px 25px 30px 30px;
            box-sizing: border-box;
            border-bottom: 1px solid #dededf;
            background: #fff;
            img {
                width: 140px;
                height: 140px;
                margin-right: 15px;
            }
            .productInfo {
                width: calc(100% - 155px);
                padding: 0;
                margin: 0;
                h3 {
                    font-size: 26px;
                    line-height: 36px;
                }
                .sales {
                    font-size: 22px;
                    color: #999;
                }
                .price {
                    strong {
                        font-size: 28px;
                        color: #E42F46;
                    }
                    span {
                        font-size: 20px;
                        color: #999;
                        text-decoration: line-through;
                    }
                }
            }
        }
        .productItem:last-of-type {
            border-bottom: none;
        }
    }
    .cartIcon {
        width: 100px;
        height: 100px;
        position: fixed;
        right: 40px;
        bottom: 180px;
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/mall/mallIndex.vue